import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {push} from 'react-router-redux';

import {request} from '../../containers/actions';
import Mark from './mark.js';

//Radium(Marker)
export default class Marker extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
    }

    componentDidMount() {
        this.fetch.bind(this)();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.questionId && !this.props.params.questionId)
            this.fetch.bind(this)();
    }

    async fetch() {
        var date = Date.now(); 
        const response = await this.context.store.dispatch(request({
            path: '/examination-question/?limit=1000&uid='+date,
        }));
        this.setState({questions: response.results});
    }

    render() {
        if (this.props.params.questionId)
            return <Mark questionId={this.props.params.questionId}/>; 
        const tdStyle = {
            verticalAlign: 'middle',
            lineHeight: '2em',
            borderTop: '.0625em solid #eaeaea',
            borderBottom: '.0625em solid #eaeaea',
            whiteSpace: 'nowrap',
            textAlign: 'right',
            fontFamily: 'IRANSans',
            paddingLeft: '.5em',
            paddingRight: '.5em',
        };
        const thStyle = {...tdStyle, backgroundColor: '#eaeaea'};
        return <table style={{borderCollapse: 'collapse', width: '100%'}}>
            <thead>
                <tr>
                    <th style={thStyle}>{window.gettext('Examination')}</th>
                    <th style={thStyle}>{window.gettext('Question Index')}</th>
                    <th style={thStyle}>{window.gettext('Marked')}</th>
                    <th style={thStyle}>{window.gettext('Remaining')}</th>
                </tr>
            </thead>
            <tbody>
                {_.map(this.state.questions, (row, index) => <tr
                    key={row.id}
                    style={{
                        backgroundColor: index % 2 === 0 ? 'white' : '#fafafa',
                        verticalAlign: 'middle',
                        lineHeight: '2em',
                        borderTop: '.0625em solid #eaeaea',
                        borderBottom: '.0625em solid #eaeaea',
                        fontSize: '.8em',
                        whiteSpace: 'nowrap',
                        textAlign: 'right',
                        fontFamily: 'IRANSans',
                        paddingLeft: '.5em',
                        paddingRight: '.5em',
                        cursor: this.props.readonly ? 'default' : 'pointer',
                    }}
                    onClick={() => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + `${row.id}/`,
                    ))}>
                    <td style={{...tdStyle, textAlign: 'right'}}>{row.examination}</td>
                    <td style={tdStyle}>{(row.index + 1).persian()}</td>
                    <td style={tdStyle}>{row.marked.persian()}</td>
                    <td style={tdStyle}>{row.remaining.persian()}</td>
                </tr>)}
            </tbody>
        </table>;
    }
}
